var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path, _g8, _g9, _g0, _g1, _g10, _g11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogounicolorebleu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    viewBox: "0 0 192 192",
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.25 0h115.5C174.875 0 192 17.125 192 38.25v115.5c0 21.125-17.125 38.25-38.25 38.25H38.25C17.125 192 0 174.875 0 153.75V38.25C0 17.125 17.125 0 38.25 0m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.21 0h171.58v171.578H10.21Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 0C48.621 0 10.21 38.41 10.21 85.79c0 47.378 38.411 85.788 85.79 85.788s85.79-38.41 85.79-85.789S143.378 0 96 0m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 13h146v145H23Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.836 13.906 144.047-.281.281 144.047-144.047.281Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.86 13.766c-39.778.078-71.962 32.386-71.883 72.164.078 39.777 32.386 71.96 72.164 71.883 39.777-.079 71.96-32.387 71.882-72.165-.078-39.777-32.386-71.96-72.164-71.882m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.45 25.691h11.542v60.09H89.45Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.45 42.367c0-9.195 2.585-16.644 5.769-16.644 3.187 0 5.773 7.449 5.773 16.644v26.774c0 9.191-2.586 16.64-5.773 16.64-3.184 0-5.77-7.449-5.77-16.64Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.152 74.516h14.13v14.129h-14.13Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.219 74.516a7.066 7.066 0 0 0-7.067 7.062 7.067 7.067 0 0 0 7.067 7.067 7.065 7.065 0 0 0 0-14.129m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.734 166H58v17H34.734Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.387 122.035h108.597v69.75H48.387Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108 122.035h22V151h-22Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 122.035h22V151H62Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.781 166.574h122.203v16.414H34.781Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103 122.035h41v69.75h-41Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 122.035h41v69.75H48Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92 77h49v40H92Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m95.95 74.516 47.265 37.097-6.504 8.285-47.266-37.093Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.105 101.32c7.23 5.676 11.637 12.133 9.84 14.422s-9.113-.457-16.343-6.133l-21.063-16.53c-7.23-5.673-11.637-12.13-9.84-14.419s9.114.457 16.344 6.133Zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-19.2-19.2h230.4v230.4H-19.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#24346b",
    d: "M10.21 0h171.58v171.578H10.21Zm0 0"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m23.836 13.906 144.047-.281.281 144.047-144.047.281Zm0 0"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#24346b",
    d: "M89.45 85.781V25.738h11.542v60.043Zm0 0"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#24346b",
    d: "M88.152 74.516h14.13v14.129h-14.13Zm0 0"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#24346b",
    d: "M57.078 166.629H42.215l-7.434 16.168H51.7z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#24346b",
    d: "M115.504 140.793H76.492l2.18-10.195h34.652l.153.71ZM103.96 86.832l.223 1.035.21.985H87.606l-.359 1.664h17.504l.523 2.449h-18.55l.523-2.45.36-1.663.43-2.024.066-.293-.067.297Zm-.09-.43.082.391-.23-1.082Zm6.613 30.918 1.496 7H80.016l1.496-7Zm-2.039-9.539 1.09 5.094h-27.07l1.09-5.094Zm-.707-3.297H84.262l.828-3.875h21.82Zm-1.98-9.257.601 2.82H85.637l.652-3.043h19.422Zm51.457 87.57-7.43-16.168h-14.863l-5.426-16.313h12.79l-4.38-9.523h-11.578l-3.394-10.195h10.289l-2.887-6.278h-9.488l-2.172-6.527-.156-.473h8.597l-2.043-4.445h-8.031l-1.695-5.094h7.386l-1.515-3.297h-6.969l-1.29-3.875h6.478l-1.176-2.562h-6.153l-.148-.445-.863-2.598h5.765l-.941-2.04h-5.504l-.816-2.448h5.195l-.766-1.664h-4.98l-.676-2.02h4.73l-.636-1.387h-4.551l-.313-.933h-4.14l.2.933H88.331l.2-.933H84.39l-.309.933h-4.55l-.637 1.387h4.726l-.476 1.43-.196.59h-4.984l-.766 1.664h5.196l-.817 2.449h-5.504l-.937 2.039h5.765L80.5 96.21l-.61 1.836h-6.152l-1.18 2.562h6.477l-1.289 3.875h-6.969l-1.515 3.297h7.386l-1.691 5.094h-8.035l-2.043 4.445h8.598l-2.329 7H61.66l-2.883 6.278h10.285l-3.39 10.195H54.09l-4.38 9.523h12.794l-14.027 42.172h16.957l9.02-42.172h43.089l9.023 42.172h16.954l-3.223-9.691z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24346b",
    d: "m70.965 166.629-3.461 16.168h56.988l-3.46-16.168zm59.371-42.309h-9.488l2.086 6.278h10.289Zm-18.356 0H80.016l-1.344 6.278h34.652Zm-40.832 0H61.66l-2.883 6.278h10.285zm66.758 16.473h-11.578l3.168 9.523h12.79Zm-22.402 0H76.492l-2.039 9.523h43.09Zm-49.832 0H54.09l-4.38 9.523h12.794z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#24346b",
    d: "M115.348 107.781h-6.903l1.09 5.094.95 4.445 1.495 7 1.344 6.278 2.18 10.195 2.039 9.523h11.953l-3.168-9.523-3.394-10.195-2.086-6.278-2.328-7-1.477-4.445z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#24346b",
    d: "M83.555 107.781h-6.907l-1.691 5.094-1.48 4.445-2.329 7-2.085 6.278-3.391 10.195-3.168 9.523h11.95l2.038-9.523 2.18-10.195 1.344-6.278 1.496-7 .953-4.445z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#24346b",
    d: "M149.785 166.629h-14.863l5.375 16.168h16.918Zm-28.754 0H70.965l-3.461 16.168h56.988Zm-63.953 0H42.215l-7.434 16.168H51.7z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#24346b",
    d: "M107.605 84.512h-4.14l23.101 107.976h16.954z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#24346b",
    d: "M88.531 84.512h-4.14L48.477 192.488h16.957z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#24346b",
    d: "m95.95 74.516 47.234 37.07-6.504 8.289-47.235-37.07Zm0 0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogounicolorebleu);
export default __webpack_public_path__ + "static/media/Logo unicolore bleu.0981655822c8c5c632a74be0cd931639.svg";
export { ForwardRef as ReactComponent };